import { verificaAcesso } from '@/routesAccess'
import Pendente from '@/views/DePara/Franqueado/FranqueadoPendente'
import Revisao from '@/views/DePara/Franqueado/FranqueadoRevisao'
import Aprovado from '@/views/DePara/Franqueado/FranqueadoAprovado'

const routerName = 'Franqueado'

export const Franqueado =  [
  {
    path: `pendente/:customerId`,
    name: 'de-para-franqueado-pendente',
    component: Pendente,
    beforeEnter: verificaAcesso,
    props: true,
    meta: { requiresAuth: true, rule: 'DePara', contexto: 'pendente' }
  },
  {
    path: `revisao/:customerId`,
    name: 'de-para-franqueado-revisao',
    component: Revisao,
    beforeEnter: verificaAcesso,
    props: true,
    meta: { requiresAuth: true, rule: 'DePara', contexto: 'revisao' }
  },
  {
    path: `aprovado/:customerId`,
    name: 'de-para-franqueado-aprovado',
    component: Aprovado,
    beforeEnter: verificaAcesso,
    props: true,
    meta: { requiresAuth: true, rule: 'DePara', contexto: 'aprovado' }
  },
]

